export const getMOTData = (state) => (
  state?.data && state?.data?.getGovVehicleData
    ? JSON.parse(state?.data?.getGovVehicleData?.data)
    : null
);

export const getMOTError = (state) => getMOTData(state)?.errorCode;

export const getMOTHasError = (state) => getMOTError(state) !== undefined;

export const getMOTVrm = (state) => getMOTData(state)?.registration;

// Additional Query Variables
export const getMOTAdditionalQueryVariables = () => ({ type: 'mot,tax' });
